/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MultiNightRatesResponse,
} from '../models/index';
import {
    MultiNightRatesResponseFromJSON,
    MultiNightRatesResponseToJSON,
} from '../models/index';

export interface HotelHotelIdMultiNightRatesGetRequest {
    hotelId: number;
    startDate: string;
    endDate: string;
    nights: string;
}

/**
 * 
 */
export class RatesApi extends runtime.BaseAPI {

    /**
     * Get multi-night rates for a hotel
     */
    async hotelHotelIdMultiNightRatesGetRaw(requestParameters: HotelHotelIdMultiNightRatesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MultiNightRatesResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling hotelHotelIdMultiNightRatesGet().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling hotelHotelIdMultiNightRatesGet().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling hotelHotelIdMultiNightRatesGet().'
            );
        }

        if (requestParameters['nights'] == null) {
            throw new runtime.RequiredError(
                'nights',
                'Required parameter "nights" was null or undefined when calling hotelHotelIdMultiNightRatesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['nights'] != null) {
            queryParameters['nights'] = requestParameters['nights'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/{hotel_id}/multi_night_rates`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MultiNightRatesResponseFromJSON(jsonValue));
    }

    /**
     * Get multi-night rates for a hotel
     */
    async hotelHotelIdMultiNightRatesGet(requestParameters: HotelHotelIdMultiNightRatesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MultiNightRatesResponse> {
        const response = await this.hotelHotelIdMultiNightRatesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
